import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { useSettings } from "@/lib/useSettings";
import { Facebook, Instagram, Linkedin, Clock } from "lucide-react";

export function Footer() {
  const { lang, t } = useLang();
  const { settings } = useSettings();
  const c = settings.company ?? {};
  
  const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';
  
  // Get services from menu if available
  const menuServices = settings.menu?.find((m: any) => m.type === "megamenu")?.items || [];

  return (
    <footer className="relative bg-primary text-primary-foreground mt-16" style={{ backgroundImage: `url('/uploads/footer_zemin.png')`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
      <div className="absolute inset-0 bg-primary/94" />
      <div className="relative container mx-auto px-4 py-20 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img 
              src="/awork1_logo.png"
              alt={c.name ?? "Awork"} 
              className="h-10 w-auto object-contain bg-white p-1 rounded" 
            />
          </div>
          <p className="text-sm opacity-90 leading-relaxed mb-4">{c[`slogan_${lang}`] ?? ""}</p>
          <Link to="/about" className="inline-block text-sm font-medium opacity-90 hover:opacity-100 hover:underline">
            {t("nav.about")}
          </Link>
        </div>

        <div>
          <h4 className="font-bold mb-4">{t("section.services")}</h4>
          <ul className="space-y-2 text-sm">
            {menuServices.map((s: any, idx: number) => (
              <li key={idx}>
                <Link to={s.path} className="hover:underline opacity-90">{s[lang === "tr" ? "title_tr" : "title_en"]}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold mb-4 flex items-center gap-2"><Clock size={18} />{t("common.hours")}</h4>
          <p className="text-sm opacity-90 mb-4">{c[`hours_${lang}`]}</p>
          <h4 className="font-bold mb-3">{t("common.followUs")}</h4>
          <div className="flex gap-3">
            {c.social?.instagram && <a href={c.social.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><Instagram size={18} /></a>}
            {c.social?.facebook && <a href={c.social.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><Facebook size={18} /></a>}
            {c.social?.linkedin && <a href={c.social.linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><Linkedin size={18} /></a>}
            {c.social?.twitter && <a href={c.social.twitter} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></a>}
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10 py-4 text-center text-sm opacity-80">
        © {new Date().getFullYear()} {c.name} — {t("common.allRights")}
      </div>
    </footer>
  );
}
